var map = {
	"./atendente.png": "2137",
	"./banner.png": "ec24",
	"./consulta.png": "9178",
	"./icon-user.png": "a2ed",
	"./logo-white.png": "d939",
	"./logo.png": "cf05",
	"./medico.png": "b855",
	"./paciente.png": "8631"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";